/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 05/06/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Buscador de remisiones en modal
*      3       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Ordena resultados de remisiones por ID
*      4       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Bloquea buscador sin devolución nueva
*      5       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Estados anti fallas para captura de devoluciones
*      6       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Modal de reimpresión de remisiones desde otras acciones
*      7       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo operativo por caja cerrada y encabezado PC/Folio
*      8       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Cierre de buscador al terminar registro de cantidades
 *      9       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Cierre de buscador al registrar partida individual
 *      10      | 11/06/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo cruzado con ventas, alert del sistema, quita reorden al editar, cero en remisión, disablePagination y navegación por flechas
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Box, Select, MenuItem, IconButton, Modal, Typography, Button, Chip, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

import { useSesion } from "../../context/System/SesionContext";
import { useTools } from "../../context/Tools/ToolsContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useInventarios } from "../../context/Inventarios/InventariosContext"
import { useRequest } from "../../context/System/RequestContext";
import { useLayout } from "../../context/System/LayoutContext";
import { apiStatusCaja } from "../../settings/ApiConfig";

import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas";
import SizeSoftXDetallesVentas from "../leyout/SizeSoftXDetallesVentas";
import SizeSoftXVentasLayout from "../leyout/SizeSoftXVentasLayout";
import SizeSoftXAlert from "../utils/SizeSoftXAlert";
import SizeSoftXLectorCodigoBarrasGeneral from "../leyout/SizeSoftXLectorCodigoBarrasGeneral";
import SizeSoftXModal from "../leyout/SizeSoftXModal";
import MnuDevolucionesActions from "./MnuDevolucionesActions";
import ModalReimpresionRemisiones from "./ModalReimpresionRemisiones";
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess";
import { useFormTabLock } from "../../hooks/useFormTabLock";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FrmLoginValidate from "../administracion/FrmLoginValidate";

const modalBuscarRemisionesStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(1180px, 94vw)",
  height: "86vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  p: 2,
  display: "flex",
  flexDirection: "column",
  gap: 1,
  overflow: "hidden",
};

export default function FrmDevoluciones() {
  const panelCodigoBarras = useRef(null);

  const { isLocked: isFormLocked } = useFormTabLock('ventas', {
    title: 'Ventas'
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isFormLocked) {
      handleOpenAlert("El formulario de Ventas o Devoluciones ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.", "error");
      setTimeout(() => {
        handleClickRegresarMainDashboard();
      }, 900);
    }
  }, [isFormLocked]);

  const { parametrosCajaForm, handleObtenerParametrosCaja, usuarioData = {} } = useSesion();
  const { GetRequest } = useRequest();
  const { handleOpenAlert } = useLayout();
  const [listaAlmacenesExhibidoresOrdenada, setListaAlmacenesExhibidoresOrdenada] = useState("");
  const [almacenExhibidor, setAlmacenExhibidor] = useState(parametrosCajaForm.dominio.toString().trim().toUpperCase());

  const skipNextBlurRef = useRef(false);
  const submittingRef = useRef(new Set());
  const descriptionRef = useRef(null);

  const {
    caja,
    remision,
    setRemision,
    filtro,
    setFiltro,
    listaCajas,
    listaRemisiones,
    setListaRemisiones,
    handleCargarCajasSistema,
    handleChangeCaja,
    retotalizarCuentaDevolucion,
    handleRegistrarArticuloDevolucion,
    statusWaiting,
    handleBuscarArticuloCodigoBarras,
    listaDevolucionesSelectas,
    setListaDevolucionesSelectas,
    ventaTotales,
    partidaSeleccionada,
    setPartidaSeleccionada,
    handleObtenerVentasPorFiltroCaja,
    setStatusWaiting,
    handleEliminarDevolucion,
    handleEliminarPartidaDevolucion,
    handleApicarDevolucion,
    handleClickNuevaDevolucion,
    statusEnableFieldsDevolucion,
  } = useTools();

  const { listaAlmacenesExhibidoresGeneral, handleObtenerAlmacenesExhibidores } = useInventarios();

  const { handleClickRegresarMainDashboard, handleInicializarVentanaVentas } = useVentas();

  const [partidaSeleccionadaRemision, setPartidaSeleccionadaRemision] = useState({});
  const [conceptoDraft, setConceptoDraft] = useState({}); // { [rowId]: "texto" }
  const [openModalBuscarRemisiones, setOpenModalBuscarRemisiones] = useState(false);
  const [openModalReimpresionRemisiones, setOpenModalReimpresionRemisiones] = useState(false);
  const [statusCajaActual, setStatusCajaActual] = useState(null);
  const cajaAbierta = Boolean(statusCajaActual?.abierta);
  const capturaActivaDevolucion = !statusEnableFieldsDevolucion && cajaAbierta;
  const capturaActivaRef = useRef(capturaActivaDevolucion);

  const [fechaBusqueda, setFechaBusqueda] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d;
  });
  const [openModalValidatorFecha, setOpenModalValidatorFecha] = useState(false);
  const [fechaBloqueada, setFechaBloqueada] = useState(true);

  useEffect(() => {
    capturaActivaRef.current = capturaActivaDevolucion;
  }, [capturaActivaDevolucion]);

  // =========================
  //  REFRESH 
  // =========================
  const refreshFiltroCaja = async (overrides = {}) => {
    const entity = {
      caja: overrides.caja ?? (caja ?? ""),
      remision:
        overrides.remision ??
        (remision == null || remision === "" ? 0 : remision),
      descripcion: (overrides.filtro ?? filtro ?? "").trim(),
      fechaventa: overrides.fechaventa ?? fechaBusqueda,
    };

    setStatusWaiting(true);
    await handleObtenerVentasPorFiltroCaja(entity);
    setStatusWaiting(false);
  };

  // =========================
  //  HANDLERS
  // =========================
  const handleChangeFilter = (e) => setFiltro(e.target.value);
  const handleChangeRemision = (e) => setRemision(e.target.value);

  const onEnterAplicar = async () => {
    if (!cajaAbierta) return;

    const filtroVal = (filtro ?? "").trim();
    const remisionVal = (remision ?? "").toString().trim();

    if (filtroVal.length === 0 && (remisionVal === "" || remisionVal === "0")) {
      handleOpenAlert("Debe ingresar al menos 3 caracteres en el filtro para realizar la búsqueda.", "warning");
      return;
    }

    if (filtroVal.length > 0 && filtroVal.length < 3) {
      handleOpenAlert("El filtro de búsqueda debe tener al menos 3 caracteres.", "warning");
      return;
    }

    await refreshFiltroCaja();
  };

  const verificarStatusCaja = async () => {
    if (!parametrosCajaForm.caja || parametrosCajaForm.caja === "CAJA-DEFAULT") {
      setStatusCajaActual({ abierta: false, status: "SIN CAJA" });
      return;
    }

    const response = await GetRequest({
      url: apiStatusCaja.replace("{caja}", parametrosCajaForm.caja),
    });

    if (response.hasError) {
      setStatusCajaActual({ abierta: false, status: "ERROR" });
      handleOpenAlert(response.message || "No se pudo verificar el estado de la caja", "error");
      return;
    }

    setStatusCajaActual(response.result);
  };

  const abrirModalBuscarRemisiones = () => {
    if (!cajaAbierta) {
      handleOpenAlert("La caja esté cerrada. No se pueden capturar devoluciones.", "warning");
      return;
    }
    if (!capturaActivaRef.current) return;
    setOpenModalBuscarRemisiones(true);
    setTimeout(() => {
      const input = document.getElementById("filtro-devoluciones");
      input?.focus();
      input?.select();
    }, 120);
  };

  const cerrarModalBuscarRemisiones = () => {
    setOpenModalBuscarRemisiones(false);
    panelCodigoBarras.current?.focusAndSelect?.();
  };

  const handleChangeCantidadDevolucion = (row, nuevaCantidad) => {
    const nuevaLista = (listaRemisiones ?? []).map((item) => {
      if (item.id === row.id) return { ...item, cantidaddevolucion: nuevaCantidad };
      return item;
    });
    setListaRemisiones(nuevaLista);
  };

  const handleResetCantidadesEdicion = () => {
    const nuevaLista = (listaRemisiones ?? []).map((item) => ({
      ...item,
      cantidaddevolucion: 0,
      conceptodevolucion: "",
    }));
    setListaRemisiones(nuevaLista);
    setConceptoDraft({});
  };

  const handleCommitConcepto = (row, concepto) => {
    const val = (concepto ?? "").trim();
    const nuevaLista = (listaRemisiones ?? []).map((item) => {
      if (item.id === row.id) return { ...item, conceptodevolucion: val };
      return item;
    });
    setListaRemisiones(nuevaLista);
  };

  const norm = (v) => (v ?? "").toString().trim().toUpperCase();

  const yaExisteEnDevoluciones = (row) => {
    const clave = norm(row.clavearticulo ?? row.claveArticulo ?? row.clave ?? row.codigo ?? row.sku);
    const medida = norm(row.medida);
    const destino = norm(row.almacenexhibidor); // opcional

    return (listaDevolucionesSelectas ?? []).some((x) => {
      const xClave = norm(x.clavearticulo ?? x.claveArticulo ?? x.clave ?? x.codigo ?? x.sku);
      const xMedida = norm(x.medida);
      const xDestino = norm(x.almacenexhibidor); // opcional

      // Si quieres que el duplicado sea SOLO por clave+medida:
      return xClave === clave && xMedida === medida;

      // Si ademés debe ser por destino también, usa esto:
      // return xClave === clave && xMedida === medida && xDestino === destino;
    });
  };

  const handleRegistrarDevolucionUI = async (e, row, conceptoFromUI, cerrarAlRegistrar = false) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();

    if (yaExisteEnDevoluciones(row)) {
      return;
    }

    const rowId = row?.id;
    if (rowId == null) return;

    // evita duplicados por Enter/click doble
    if (submittingRef.current.has(rowId)) return;
    submittingRef.current.add(rowId);

    try {

      const concepto = (conceptoFromUI ?? conceptoDraft[rowId] ?? row.conceptodevolucion ?? "").trim();

      // commit al estado (visual)
      handleCommitConcepto(row, concepto);

      const almacenx = row.almacenexhibidor.trim().toUpperCase();
      const rowToSend = { ...row, conceptodevolucion: concepto, almacenexhibidororigen: almacenx, almacenexhibidordestino: almacenExhibidor };
      if (!concepto) return;

      const resp = await handleRegistrarArticuloDevolucion(e, rowToSend);

      if (cerrarAlRegistrar) {
        cerrarModalBuscarRemisiones();
      }

      return resp;
    } finally {
      // libera el lock aunque truene
      submittingRef.current.delete(rowId);
    }
  };

  const handleRegistrarCantidadesModal = async () => {
    if (!capturaActivaDevolucion) return;

    const rows = (listaRemisiones ?? []).filter((row) => Number(row.cantidaddevolucion || 0) > 0);

    const faltaConcepto = rows.some((row) => !(conceptoDraft[row.id] ?? row.conceptodevolucion ?? "").trim());
    if (faltaConcepto) {
      handleOpenAlert("Capture el concepto de devolución en todas las partidas seleccionadas.", "warning");
      return;
    }

    for (const row of rows) {
      const concepto = (conceptoDraft[row.id] ?? row.conceptodevolucion ?? "").trim();
      await handleRegistrarDevolucionUI(null, row, concepto);
    }

    cerrarModalBuscarRemisiones();
  };

  const handleBuscarArticuloCodigoBarrasActivo = (data) => {
    if (!capturaActivaRef.current) return;
    handleBuscarArticuloCodigoBarras(data);
  };

  const handleChangeAlmacenexhibidor = (e, newDat) => {
    setAlmacenExhibidor(newDat.nombre);
  };

  const handleValidarFechaBusqueda = (status, username) => {
    if (!status) return;
    setFechaBloqueada(false);
  };

  const handleToggleFechaBusqueda = () => {
    if (!fechaBloqueada) {
      setFechaBloqueada(true);
      const d = new Date();
      d.setMonth(d.getMonth() - 1);
      setFechaBusqueda(d);
      return;
    }
    setOpenModalValidatorFecha(true);
  };

  // =========================
  //  LISTAS DERIVADAS
  // =========================
  const listaCajasOrdenada = useMemo(() => {
    return (listaCajas ?? [])
      .slice()
      .sort((a, b) => (a.caja ?? "").localeCompare(b.caja ?? ""))
      .map((item) => ({ id: item.id, caja: (item.caja ?? "").trim() }));
  }, [listaCajas]);

  let listaAlmacenesExhibidoresAutoComplete = [];
  listaAlmacenesExhibidoresGeneral.map((y) =>
    listaAlmacenesExhibidoresAutoComplete.push({
      id: y.id,
      nombre: y.almacenexhibidor.toString().trim().toUpperCase(),
    })
  );

  // =========================
  //  EFFECTS
  // =========================
  useEffect(() => {
    retotalizarCuentaDevolucion(listaDevolucionesSelectas);
  }, [listaDevolucionesSelectas]);

  useEffect(() => {
    if (!capturaActivaDevolucion) {
      setOpenModalBuscarRemisiones(false);
    }
  }, [capturaActivaDevolucion]);

  useEffect(() => {
    handleObtenerParametrosCaja();
    if (listaAlmacenesExhibidoresGeneral.length === 0) {
      handleObtenerAlmacenesExhibidores("GENERAL");
    }
    if (!listaCajas || listaCajas.length === 0) {
      handleCargarCajasSistema();
    }
  }, []);

  useEffect(() => {
    verificarStatusCaja();
  }, [parametrosCajaForm.caja]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F4") {
        e.preventDefault();
        e.stopPropagation();
        handleClickRegresarMainDashboard();
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F1") {
        e.preventDefault();
        e.stopPropagation();
        abrirModalBuscarRemisiones();
        return;
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F7") {
        e.preventDefault();
        e.stopPropagation();
        if (!capturaActivaDevolucion) return;

        handleEliminarPartidaDevolucion(e, partidaSeleccionada.id);
        return;
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F11") {
        e.preventDefault();
        e.stopPropagation();
        if (!capturaActivaDevolucion) return;

        handleEliminarDevolucion();
        return;
      }

      if (e.altKey && e.key.trim().toUpperCase() === "A") {
        e.preventDefault();
        e.stopPropagation();
        if (!capturaActivaDevolucion || !listaDevolucionesSelectas?.length) return;
        handleApicarDevolucion(async () => {
          await handleInicializarVentanaVentas();
        });
        return;
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F3") {
        e.preventDefault();
        e.stopPropagation();
        if (!cajaAbierta) {
          handleOpenAlert("La caja esté cerrada. No se pueden capturar devoluciones.", "warning");
          return;
        }
        handleClickNuevaDevolucion();
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleClickRegresarMainDashboard]);

  return (
    <Fragment>
      <SizeSoftXVentasLayout
        titlePage="Módulo de devoluciones"
        buttonActions={
          <MnuDevolucionesActions
            onFocusBuscar={abrirModalBuscarRemisiones}
            onOpenReimpresion={() => setOpenModalReimpresionRemisiones(true)}
            cajaAbierta={cajaAbierta}
          />
        }
        detailComponent={null}
      >
        <div className="title-page venta-header-card devoluciones-status-header">
          <div style={{ minWidth: '150px' }}>
            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CAJA</div>
            <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{parametrosCajaForm.caja}</div>
            <Chip
              label={statusCajaActual?.status || (cajaAbierta ? "ABIERTA" : "CERRADA")}
              color={cajaAbierta ? "success" : "error"}
              size="small"
              sx={{ mt: 0.5, fontSize: '10px', height: '20px' }}
            />
          </div>
          <div style={{ minWidth: '120px' }}>
            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>FOLIO DEVOLUCIÓN</div>
            <div style={{ fontSize: '15px', fontWeight: 'bold' }}>
              {capturaActivaDevolucion ? (parametrosCajaForm.folioventa || 0) : 0}
            </div>
          </div>
          <div style={{ minWidth: '130px' }}>
            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>ATENDE</div>
            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{usuarioData.Usuario || usuarioData.usuario || ""}</div>
            <div style={{ fontSize: '11px', color: '#888' }}>{usuarioData.Nombre || usuarioData.nombre || ""}</div>
          </div>
        </div>

        <Modal open={openModalBuscarRemisiones && capturaActivaDevolucion} onClose={cerrarModalBuscarRemisiones}>
          <Box sx={modalBuscarRemisionesStyle}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Buscar remisiones para devolución
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  onClick={handleRegistrarCantidadesModal}
                  disabled={!capturaActivaDevolucion || !(listaRemisiones ?? []).some((row) => Number(row.cantidaddevolucion || 0) > 0)}
                >
                  Registrar cantidades
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={handleResetCantidadesEdicion}
                  disabled={!capturaActivaDevolucion || !(listaRemisiones ?? []).some((row) => Number(row.cantidaddevolucion || 0) > 0)}
                >
                  Limpiar edición
                </Button>
                <Button variant="outlined" onClick={cerrarModalBuscarRemisiones}>
                  Cerrar
                </Button>
              </Box>
            </Box>

            <div className="header-page-devoluciones modal-devoluciones-buscador">
              <div className="filters-section-devoluciones">
              <Autocomplete
                freeSolo
                noOptionsText={"Sin resultados"}
                disableClearable
                id="caja-autocomplete"
                options={listaCajasOrdenada}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  if (option?.caja) return option.caja;
                  return "";
                }}
                value={listaCajasOrdenada.find((x) => x.caja === caja) ?? (caja ?? "")}
                onChange={(e, newDat) => handleChangeCaja(e, newDat)}
                renderInput={(params) => <TextField {...params} label="Caja:" required />}
                sx={{ width: "300px", height: "6.3vh", padding: "0", margin: "1px", '& .MuiInputBase-input': { fontSize: '1.2rem' } }}
                disabled={statusEnableFieldsDevolucion}
              />

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <DatePicker
                  selected={fechaBusqueda}
                  onChange={(date) => setFechaBusqueda(date)}
                  dateFormat="dd/MM/yyyy"
                  disabled={fechaBloqueada}
                  customInput={
                    <TextField autoComplete="off"
                      label="Desde fecha:"
                      size="small"
                      sx={{ width: '160px', '& .MuiInputBase-input': { fontSize: '1.2rem' } }}
                      disabled={fechaBloqueada}
                    />
                  }
                />
                <Tooltip title={fechaBloqueada ? "Desbloquear fecha (solo usuarios autorizados)" : "Restablecer a 30 días"}>
                  <IconButton size="small" onClick={handleToggleFechaBusqueda}>
                    {fechaBloqueada ? <LockIcon fontSize="small" /> : <LockOpenIcon fontSize="small" color="primary" />}
                  </IconButton>
                </Tooltip>
              </Box>

              <TextField
                inputRef={descriptionRef}
                name="filtro"
                label="Filtro:"
                id="filtro-devoluciones"
                value={filtro ?? ""}
                onChange={handleChangeFilter}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    await onEnterAplicar();
                  }
                }}
                type="text"
                autoComplete="off"
                inputProps={{ maxLength: 20, minLength: 3 }}
                sx={{ margin: ".1rem .1rem", width: "270px", '& .MuiInputBase-input': { fontSize: '1.2rem' } }}
                disabled={statusEnableFieldsDevolucion}
                slotProps={{
                    htmlInput: {
                        enterKeyHint: 'enter'
                    }
                }}
              />

              <TextField
                name="remision"
                label="Remisión:"
                value={remision === "0" || remision === 0 ? "" : (remision ?? "")}
                onChange={handleChangeRemision}
                onFocus={(e) => {
                    if (remision === "0" || remision === 0) {
                      setRemision("");
                    }
                    e.target.select();
                  }}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    await onEnterAplicar();
                  }
                }}
                type="text"
                autoComplete="off"
                inputProps={{ maxLength: 20, minLength: 3 }}
                sx={{ margin: ".1rem .1rem", width: "270px", '& .MuiInputBase-input': { fontSize: '1.2rem' } }}
                disabled={statusEnableFieldsDevolucion}
              />

              <Autocomplete
                freeSolo
                noOptionsText={"Sin resultados"}
                disableClearable
                id={"id"}
                name={"AlmacenExhibidor"}
                options={listaAlmacenesExhibidoresAutoComplete}
                getOptionLabel={(option) => typeof option === "string" ? option : option.nombre}
                value={listaAlmacenesExhibidoresAutoComplete.find(x => x.nombre === almacenExhibidor) || almacenExhibidor}
                onChange={(e, newDat) => handleChangeAlmacenexhibidor(e, newDat)}
                renderInput={(params) => (
                  <TextField {...params} label="Almacén o Exhibidor:" required />
                )}
                sx={{ width: '300px', height: '6.3vh', '& .MuiInputBase-input': { fontSize: '1.2rem' } }}
                disabled={statusEnableFieldsDevolucion}
              />
              </div>
              <div className="tabla-devoluciones-buscador">
                <div className="tabla">
                  <SizeSoftXTableVentas
                    rowsPerPageIntro={6}
                    columns={[
                      {
                        hideSort: true,
                        render: (row) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              padding: "5px",
                              background: "white",
                              borderRadius: "9px",
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <Select
                              label="Cantidad devolución"
                              value={row.cantidaddevolucion || 0}
                              onChange={(e) =>
                                handleChangeCantidadDevolucion(row, parseInt(e.target.value, 10))
                              }
                              size="small"
                              sx={{ width: 100 }}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                            >
                              {[...Array((row.cantidadarticulo || 0) + 1).keys()]
                                .slice(1)
                                .map((num) => (
                                  <MenuItem key={num} value={num}>
                                    {num}
                                  </MenuItem>
                                ))}
                            </Select>

                            {row.cantidaddevolucion > 0 && (
                              <>
                                <TextField
                                  name="concepto"
                                  label="Concepto devolución:"
                                  value={conceptoDraft[row.id] ?? row.conceptodevolucion ?? ""}
                                  onBlur={() => {
                                    if (skipNextBlurRef.current) {
                                      skipNextBlurRef.current = false;
                                      return;
                                    }
                                    handleCommitConcepto(row, conceptoDraft[row.id] ?? "");
                                  }}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setConceptoDraft((prev) => ({ ...prev, [row.id]: val }));
                                  }}
                                  onKeyDown={async (e) => {
                                    e.stopPropagation();

                                    if (e.key === "Enter") {
                                      e.preventDefault();

                                      skipNextBlurRef.current = true;

                                      const val = (conceptoDraft[row.id] ?? "").trim();

                                      await handleRegistrarDevolucionUI(e, row, val, true);
                                    }
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  onMouseDown={(e) => e.stopPropagation()}
                                  type="text"
                                  autoComplete="off"
                                  inputProps={{ maxLength: 60, minLength: 3 }}
                                  sx={{ margin: ".1rem .1rem", width: "200px" }}
                                />

                                <IconButton onClick={(e) => handleRegistrarDevolucionUI(e, row, conceptoDraft[row.id], true)}>
                                  <AddIcon color="primary" />
                                </IconButton>
                              </>
                            )}
                          </Box>
                        ),
                      },
                      { title: "Remisión", field: "remision" },
                      { title: "Fecha venta", field: "fechaventa" },
                      { title: "Descripción", field: "descripcion" },
                      { title: "Medida", field: "medida" },
                      { title: "Cantidad", field: "cantidadarticulo" },
                      { title: "Costo para cliente", field: "costocliente" },
                      { title: "Origen", field: "almacenexhibidor" },
                      { title: "Descuento", field: "descuentoarticulo" },
                      { title: "Subtotal", field: "subtotalarticulo" },
                      { title: "IVA", field: "ivaarticulo" },
                      { title: "Total", field: "totalarticulo" },
                      { title: "Partida", field: "idpartida" },
                      { title: "Remisión", field: "remision" },
                      { title: "Caja", field: "pc" },
                    ]}
                    data={listaRemisiones}
                    disablePagination
                    id="id"
                    row={partidaSeleccionadaRemision}
                    setRow={setPartidaSeleccionadaRemision}
                    fontSize="small"
                  />
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <FrmLoginValidate
          openModal={openModalValidatorFecha}
          hancleCloseModalValidator={() => setOpenModalValidatorFecha(false)}
          tiposUsuario={["SA", "ADMINISTRADOR"]}
          handleComandoEjecucion={handleValidarFechaBusqueda}
        />

        <div className="venta-devoluciones-container">
          <div className="venta-super-left-devoluciones">
            <SizeSoftXTableVentas
              columns={[
                { title: "Folio remisión", field: "remision" },
                { title: "Caja", field: "pc" },
                { title: "Descripción", field: "descripcion" },
                { title: "Medida", field: "medida" },
                { title: "Cantidad", field: "cantidaddevolucion" },
                { title: "Costo para cliente", field: "costocliente" },
                { title: "%", field: "porcentajedescuento" },
                { title: "descuento", field: "descuentoarticulo" },
                { title: "Subtotal", field: "subtotalarticulo" },
                { title: "IVA", field: "ivaarticulo" },
                { title: "Total", field: "totalarticulo" },
                { title: "Almacén/Exhibidor Destino", field: "almacenexhibidordestino" },
                { title: "Partida", field: "idpartida" },
                { title: "Cantidad venta", field: "cantidadarticulo" },
                { title: "Concepto", field: "conceptodevolucion" },
                { title: "Remisión origen", field: "remisionorigen" },
                { title: "PC origen", field: "pcorigen" },
                { title: "Almacén/Exhibidor origen", field: "almacenexhibidororigen" },
              ]}
              data={listaDevolucionesSelectas ?? []}
              id="id"
              row={partidaSeleccionada}
              setRow={setPartidaSeleccionada}
              fontSize="small"
            />
          </div>

          <div className="venta-frame-right-devoluciones">
            <div className="framelectorcodigosbarras">
              <SizeSoftXLectorCodigoBarrasGeneral
                ref={panelCodigoBarras}
                handleRegistrarArticulo={handleBuscarArticuloCodigoBarrasActivo}
                TipoVentana={"DEVOLUCIÓN"}
                statusBotonCarga={false}
                disabled={statusEnableFieldsDevolucion}
              />
            </div>
            <SizeSoftXDetallesVentas ventasTotales={ventaTotales} />
          </div>
        </div>

        <SizeSoftXModal />
        <ModalReimpresionRemisiones
          openModal={openModalReimpresionRemisiones}
          onClose={() => setOpenModalReimpresionRemisiones(false)}
          caja={parametrosCajaForm.caja}
        />
        <SizeSoftXAlert />
        <SizeSoftXLoadingProcess open={statusWaiting} message="Procesando información, por favor espere..." />
      </SizeSoftXVentasLayout>
    </Fragment>
  );
}
